@for (item of visibleItems(); track item.field) {
  @if (item.toggle) {
    <soft-ds-button [variant]="isToggleActive(item) ? 'primary' : 'outline'"
                    size="lg"
                    (click)="toggleItem(item)"
                    data-testid="filter-menu-bar-toggle">
      @if (item.config.icon; as icon) {
        <ng-template softSlot="leading"><soft-ds-icon [name]="icon" /></ng-template>
      }
      {{ item.config.title() }}
    </soft-ds-button>
  }
  @else if (item.kind === 'dateRange') {
    <soft-page-filter-date-range-item [item]="item" [service]="service()" data-testid="filter-menu-bar-date-range" />
  }
  @else if (item.kind === 'dateRangeReference') {
    <soft-page-filter-date-range-reference-item [item]="item" [service]="service()" data-testid="filter-menu-bar-date-range-reference" />
  }
  @else if (isListItem(item)) {
    <soft-page-filter-select-item [item]="item" [service]="service()" data-testid="filter-menu-bar-item" />
  }
  @else {
    <soft-page-filter-dropdown #dropdown
                               [title]="item.config.title()"
                               [value]="itemValue(item)"
                               [icon]="item.config.icon"
                               data-testid="filter-menu-bar-item">
      <div class="filter-menu-item-panel" data-testid="filter-menu-bar-item-panel">
        <div class="filter-menu-item-content">
          @if (dropdown.open() && itemComponent(item); as component) {
            <ng-container *ngComponentOutlet="component; inputs: itemInputs(item)"></ng-container>
          }
        </div>
        <div class="filter-menu-item-footer">
          <soft-ds-button variant="primary" size="lg"
                          (click)="applyItem(item, dropdown)"
                          data-testid="filter-menu-bar-item-apply">
            {{ '#CORE_FILTER.APPLY' | translate }}
          </soft-ds-button>
        </div>
      </div>
    </soft-page-filter-dropdown>
  }
}
